var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:[
        {
            'box-layout': _vm.boxLayout,
            'collapse-sidebar': _vm.collapseSidebar,
            'rtl-layout': _vm.rtlLayout,
        },
    ],attrs:{"dark":_vm.darkMode,"id":"inspire"}},[_c('bc-progress-loader'),_c('router-view',{staticClass:"white-bg",attrs:{"auth":_vm.auth,"authenticated":_vm.authenticated}}),_c('notifications',{attrs:{"group":"loggedIn","position":"top center","animation-type":"velocity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }